import React, { type FC } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";
import { isVendorCentral } from "src/api/config";
import Avatar from "src/components/AICLayout/AICHeader/Avatar";
import LocationSelector from "src/components/AICLayout/AICHeader/LocationSelector/LocationSelector";
import PortalLogo from "src/components/AICLayout/AICHeader/PortalLogo";
import { getUsernameFromCookie, isMidwayCookieSet } from "src/cookies";

import NestNavBar from "./NestNavBar";
import "./AICHeader.css";

const AICHeader: FC<AICHeaderProps & WithTranslation> = ({
  disableCountryChange,
  fixedCountry,
  disableUrlSearchParamsUpdate,
  isNest,
}) => {
  const userName = getUsernameFromCookie();
  const isEmbeddedInVendorCentral = isVendorCentral();

  const headerClass = [
    "aic-header",
    isNest ? "aic-header--nest" : "",
    isEmbeddedInVendorCentral ? "aic-header--vendor-central" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={headerClass}>
      <div className="aic-header__content">
        <div>
          <PortalLogo isNest={isNest} />
        </div>
        <div className="aic-header__nav">
          <div className="aic-header__nav-items">
            <NestNavBar isNest={isNest} />
            <LocationSelector
              disableCountryChange={disableCountryChange}
              fixedCountry={fixedCountry}
              disableUrlSearchParamsUpdate={disableUrlSearchParamsUpdate}
            />
          </div>
          {isMidwayCookieSet() && (
            <>
              <div className="aic-header__user">
                <Avatar userAlias={userName} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export interface AICHeaderProps {
  disableCountryChange?: boolean;
  fixedCountry?: string;
  disableUrlSearchParamsUpdate?: boolean;
  isNest?: boolean;
}

export default withTranslation()(AICHeader);
